// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api-old.cgw.webcase.me',
  siteUrl: 'https://app-old.cgw.webcase.me',
  captchaSiteKey: '6LeAVwImAAAAABC9wuolgERV74-zSKBuZcljkXvI',
  tinyMceKey: 'wuufufju2uperfktitc4zno2i0gzm5rjfuzkaedrbdx9zb6e',
  appName: 'CalGames Wanted',
  logo: 'assets/images/logo.svg',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
